export const checkIfMatrixHasAtLeastOneDependency = (matrix)=>{
    return matrix.some((row)=>row.some((value)=>value !== 0));
};
